import React from "react";
import {QUARTER_SIZE} from "../../constants/cssConstants";

const QUARTERS = ['Fall', 'Winter', 'Spring', 'Summer'];

class QuarterTitles extends React.Component {
    render() {
        return(
            <div style={{display: 'flex', justifyContent: 'space-between', height: 20}}>
                {
                    QUARTERS.map((quarter) =>
                        <div style={{ width: QUARTER_SIZE }}>{quarter}</div>
                    )
                }
            </div>
        );
    }
}

export default QuarterTitles;